// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"TermsPage_pageTitle_33fyc","termContainer":"TermsPage_termContainer_1q3iA"};